<template>
    <div id="basic-task">
        <div class="container">
            <a-input placeholder="Enter new task" class="basic-task-input" v-model="form.title" />
            <a-textarea
                v-model="form.description"
                class="basic-task-input"
                placeholder="Enter task description"
                :auto-size="{ minRows: 3, maxRows: 5 }"
            />
            <div class="basic-task-assignee">
                <label>Assignee</label>
                <a-select
                    v-model="form.assigneeIds"
                    class="select-multiple"
                    mode="multiple"
                    placeholder="Select assignee"
                    :options="users"
                ></a-select>
            </div>
            <div class="basic-task-footer">
                <div @click="closeForm" style="display: contents">
                    <md-icon class="basic-task-close-btn">close</md-icon>
                </div>
                <div @click="createTask">
                    <md-icon class="basic-task-done-btn">done</md-icon>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
    name: "BasicTaskForm",
    props: {
        pipelineStageId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            form: {
                title: "",
                description: "",
                assigneeIds: [],
            },
        };
    },
    computed: {
        ...mapState({
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
            defaultWorkflow: (state) => state.tasks.defaultWorkflow,
            basicTaskForm: (state) => state.tasks.basicTaskForm,
        }),
    },
    methods: {
        ...mapActions({
            createSimpleTask: "tasks/createSimpleTask",
            setBasicTaskForm: "tasks/setBasicTaskForm",
        }),
        closeForm() {
            this.$emit("close");
        },
        createTask() {
            const form = {
                ...this.form,
                workflowId: this.defaultWorkflow._id,
                pipelineStageId: this.pipelineStageId,
            };
            this.createSimpleTask(form);
            this.closeForm();
        },
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.setBasicTaskForm({
                    ...this.basicTaskForm,
                    [this.pipelineStageId]: {
                        ...this.basicTaskForm[this.pipelineStageId],
                        form: this.form,
                    },
                });
            },
        },
        basicTaskForm: {
            deep: true,
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(newVal, oldVal)) {
                    this.form = this.basicTaskForm[this.pipelineStageId]?.form || {};
                }
            },
        },
    },
};
</script>
<style scoped lang="scss">
#basic-task {
    min-width: 300px;
    margin-top: 10px;

    .container {
        padding: 20px;
        border: 1px solid #ccc;
        border-radius: 5px;
        background-color: #fff;
        display: grid;
        gap: 20px;
        .basic-task-input {
            background: #f6f6f6 !important;
            border: transparent !important;
            border-radius: 5px !important;
        }
        .ant-input:focus {
            border: 1px solid #97a3b0 !important;
            border-color: #97a3b0 !important;
            background: white !important;
            color: black !important;
            border-right-width: 1px !important;
            outline: 0;
            -webkit-box-shadow: transparent !important;
            box-shadow: none !important;
        }

        .basic-task-assignee {
            grid-template-columns: 1fr 1fr;
            display: contents;
            label {
                font-weight: bold;
                color: #79797c;
                margin-bottom: -16px;
            }
        }

        .basic-task-footer {
            display: flex;
            gap: 10px;
            justify-content: flex-end;
            margin-bottom: -10px;
            .basic-task-close-btn {
                color: red !important;
                margin-left: 0px !important;
                font-size: 20px !important;
                cursor: pointer !important;
            }
            .basic-task-done-btn {
                margin-right: 0px !important;
                color: green !important;
                font-size: 20px !important;
                cursor: pointer !important;
            }
        }
    }
    .select-multiple {
        max-width: 290px !important;
        .ant-select-selector {
            border-radius: 5px !important;
            background: #f6f6f6 !important;
            border: 1px solid #ccc !important;
            height: 40px !important;
            .ant-select-selection-item {
                color: #79797c !important;
            }
        }
    }
}
</style>
